import { connect } from 'react-redux'
import { selectors } from '../../features/Settings'
import TemporaryLaunchFrame from '../../components/TemporaryLaunchFrame'
import { actionUsersSetUserAccessToken, actionProcessSetProgress } from '../../actions'
import localize from '../../store/localize'
import strings from '../../components/TemporaryLaunchFrame/temporary-launch-frame.json'
import attributes from '../../settings/references.json'
import { actions as toasterActions } from '../../features/Toaster'

export function mapStateToProps(state, ownProps) {
    const { servers, users, versions } = state
    const server = servers.list[servers.active]
    const user = users.list[server.shortName][ownProps.userKey]
    const userAgent = attributes.launcher.user_agent.replace('{version}', versions.ui)
    return {
        server,
        user,
        localize: value => localize(strings, selectors.getLanguage(state), value),
        userAgent,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        setAccessToken: (server, userKey, newToken) => {
            dispatch(actionUsersSetUserAccessToken(server, userKey, newToken))
        },
        displayNotification: (message) => {
            dispatch(toasterActions.addError(message))
        },
        setClientLaunchProgress: (server, userKey, progress) => {
            dispatch(actionProcessSetProgress(server, userKey, progress))
        },
    }
}

function mergeProps(stateProps, dispatchProps, ownProps) {
    return {
        server: stateProps.server,
        user: stateProps.user,
        userAgent: stateProps.userAgent,
        setAccessToken: (token) => {
            dispatchProps.setAccessToken(
                stateProps.server.shortName,
                stateProps.user.username,
                token,
            )
        },
        displayNotification: dispatchProps.displayNotification,
        setClientLaunchProgress: (progress) => {
            dispatchProps.setClientLaunchProgress(
                stateProps.server.shortName,
                stateProps.user.username,
                progress,
            )
        },
        localize: stateProps.localize,
        unMount: ownProps.unMount,
        onTokenExpired: ownProps.onTokenExpired,
    }
}

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(TemporaryLaunchFrame)



// WEBPACK FOOTER //
// ./src/containers/TemporaryLaunchFrame/temporary-launch-frame.js